import React, { FC } from 'react';
import urlJoin from 'url-join';
import { Link } from 'react-router-dom';

import { Column, Row } from 'Shared/components';
import { formatPhoneNumber } from 'Shared/utils';
import { useAppContext } from 'QuoteApp/services/providers';
import { QUOTE_APP_ROUTE } from 'Shared/constants/routes';

import styles from './styles.module.css';

export const ContactInfo: FC = () => {
  const { details, appId } = useAppContext();

  return (
    <>
      <h3 className={styles.contactInfoHeading}>Contact information</h3>
      <p>
        Please confirm the customer email for sending important post-bind
        documents. Clicking "Edit Email" will return you to the Summary page to
        make your changes.
      </p>
      <div className={styles.contactInfoForm}>
        <Row>
          <Column>
            <div className={styles.contactInfoLabel}>Phone</div>
            <span className="fs-mask">
              {formatPhoneNumber(
                details.contactInfo[details.principalInsuredId].phoneNumber
                  .value || ''
              )}
            </span>
          </Column>
          <Column>
            <div className={styles.contactInfoLabel}>
              Is this a mobile number?
            </div>
            {details.contactInfo[details.principalInsuredId].phoneType.value ===
            'mobile'
              ? 'Yes'
              : 'No'}
          </Column>
        </Row>
        <Row className={styles.contactInfoEmailRow}>
          <Column>
            <div className={styles.contactInfoLabel}>Email Address</div>
            <span className="fs-mask">
              {details.contactInfo[details.principalInsuredId].email.value ||
                ''}
            </span>
            <Link
              className={styles.contactInfoEmailEditLink}
              to={urlJoin(QUOTE_APP_ROUTE, appId, '/summary')}
            >
              Edit Email
            </Link>
          </Column>
        </Row>
      </div>
    </>
  );
};
